module.exports = __webpack_public_path__ + "img/image.2c0b0689.svg";